<div class="modal" id="custom-modal" tabindex="-1" role="dialog" aria-hidden="false"
     data-keyboard="true" data-backdrop="static" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-close="true" data-dismiss="modal" aria-label="{{t 'closeModal'}}">
          <span aria-hidden="true">&times;</span>
        </button>
        <!--<div class="modal-title" id="custom-modal-label">{{t header}}</div>-->
      </div>
      <div class="modal-body">
        {{{content}}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" data-close="true">
          <span aria-hidden="true">{{t 'closeModal'}}</span>
          <span class="screen-reader-content">{{t 'closeModal'}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
